export default {
  list: [],
  current: {
    uuid: null,
    users: [],
    files: [],
  },
};
